import React from 'react';
import classNames from 'classnames';

import styles from './WebHeading.module.scss';

interface WebHeadingProps {
  level?: number;
  className?: string;
}

const WebHeading: React.FC<WebHeadingProps> = ({ children, className, level = 1 }) => {
  return (
    <div
      className={classNames(className, styles.heading, {
        [styles[`heading-${level}`]]: level,
      })}
    >
      {children}
    </div>
  );
};

export default WebHeading;
